import * as Yup from 'yup';

export const schema = Yup.object().shape({
  transitionLevel: Yup.number()
    .required('Required')
    .min(0, 'Minimum value is 0')
    .max(150, 'Maximum value is 150'),
});
